import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserAndOrganFilter } from "@/utils/commonConfig";
import { TABLEPAI } from "@/enums/pageEnum";
import { addUserToGroup, removeUserInGroup } from "@api";
import { isArray } from "lodash-es";
import {
  CustomModal,
  ComfirmButton,
  BasicTable,
  PropsRef,
  Status,
} from "@/components";

export default function AddPubCom({ groupId }: { groupId: string }) {
  const { t } = useTranslation();
  const organizTableRef = useRef<PropsRef>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [refreshKey, setRefreshKey] = useState<number>();

  const removeUsers = (users: string[]) => {
    removeUserInGroup(users, groupId).then(() => {
      setRefreshKey(Math.random());
    });
  };

  const modalCols = [
    { title: t("userName"), dataIndex: "nickname" },
    {
      title: t("group"),
      dataIndex: "groups",
      renderText: (text: string) => {
        return isArray(text) ? text.map((item) => item.name)?.join(", ") : text;
      },
    },
    { title: t("role"), dataIndex: "role" },
    {
      title: t("status"),
      dataIndex: "status",
      renderText: (text: string) => <Status status={text} />,
    },
  ];

  const columns = [
    { title: t("userName"), dataIndex: "nickname" },
    {
      title: t("action"),
      dataIndex: "action",
      render: (_: unknown, record: { id: string }) => {
        return (
          <ComfirmButton
            buttonCogfig={{ variant: "link" }}
            onClick={() => removeUsers([record?.id])}
            title={t("remove")}
          />
        );
      },
    },
  ];

  return (
    <BasicTable
      className="min-h-[calc(100vh-250px)]"
      isDefaultToolBar={false}
      tableHeader={() => (
        <>
          <CustomModal
            title={t("add")}
            isProForm={false}
            onClick={() => {
              const userIds =
                organizTableRef.current?.handleClick() as string[];
              if (userIds && userIds?.length) {
                addUserToGroup(userIds, groupId).then(() => {
                  setRefreshKey(Math.random());
                });
              }
            }}
          >
            <BasicTable
              columns={modalCols}
              filterTableFields={UserAndOrganFilter(t("userName"), t("status"))}
              className="min-h-max"
              ref={organizTableRef}
              isDefaultToolBar={false}
              requestUrl={`${TABLEPAI.USER}?excludeGroupId=${groupId}`}
            />
          </CustomModal>
          <ComfirmButton
            buttonCogfig={{
              disabled: !selectedRowKeys.length,
              className: "ml-4",
            }}
            onClick={() => removeUsers(selectedRowKeys as string[])}
            title={t("remove")}
          />
        </>
      )}
      columns={columns}
      key={refreshKey}
      requestUrl={`${TABLEPAI.USER}/${groupId}`}
      onChangeSelected={(rowkeys) => setSelectedRowKeys(rowkeys)}
    />
  );
}
